import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition, faArrowRight, faCheck, faStar, faBan, faSuitcase } from '@fortawesome/free-solid-svg-icons';
import { IaqoboAirPermission } from 'app_locobook/shared/iaqobo-air-permission.enum';
import { IMomentDateFormat } from 'libraries/interfaces/IMomentDateFormat';
import { wenji } from 'libraries/interfaces/IWenji';
import { Yii } from 'libraries/interfaces/Yii';
import { IDropOption, maxViasList, cabinClassesList } from 'libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.component';
import { IAirSearchSegment } from '../air-search-form/air-search-segment-oneway-return/air-search-segment-oneway-return.component';
import { IAirSearchRequest } from "app_locobook/air-search/air-search.component";

class Wording {
    public readonly nextDay: string = Yii.t('wui-iqba-js', 'lendemain');
    public readonly departure: string = Yii.t('wui-iqba-js', 'départ');
    public readonly arrival: string = Yii.t('wui-iqba-js', 'arrivée');
    public readonly before: string = Yii.t('wui-iqba-js', 'avant');
    public readonly after: string = Yii.t('wui-iqba-js', 'après');
    public readonly from: string = Yii.t('wui-iqba-js', 'de');
    public readonly at: string = Yii.t('wui-iqba-js', 'à');
    public readonly stopoverTime: string = Yii.t("wui-iqba-js", "temps d'escale maximum");
    public readonly travellers: string = Yii.t("wui-iqba-js", "Voyageurs");
    public readonly adt: string = Yii.t("wui-iqba-js", "ADT");
    public readonly chd: string = Yii.t("wui-iqba-js", "CHD");
    public readonly inf: string = Yii.t("wui-iqba-js", "INF");
    public readonly priceForAdt: string = Yii.t("wui-iqba-js", "Prix par ADT");
    public readonly moreAndLess: string = Yii.t("wui-iqba-js", "+/- ");
    public readonly typeTariff: string = Yii.t("wui-iqba-js", "Types de tarif");
    public readonly companies: string = Yii.t("wui-iqba-js", "Compagnies");
    public readonly favoriteCompanies: string = Yii.t("wui-iqba-js", "Compagnies préférées");
    public readonly incluedCompanies: string = Yii.t("wui-iqba-js", "Compagnies incluses");
    public readonly excludedCompanies: string = Yii.t("wui-iqba-js", "Compagnies exclues");
    public readonly includedServices: string = Yii.t("wui-iqba-js", "Services Inclus");
    public readonly days: string = Yii.t("wui-iqba-js", "Jours");
    public readonly day: string = Yii.t("wui-iqba-js", "Jour");
    public readonly source: string = Yii.t("wui-iqba-js", "Source");
    public readonly sources: string = Yii.t("wui-iqba-js", "Sources");
    public readonly arrivalAt: string = Yii.t("wui-iqba-js", "arrivée le");
    public readonly locator: string = Yii.t('wui-iqba-js', 'Agence');
    public readonly cabin: string = Yii.t('wui-iqba-js', 'classe cabine');
    public readonly maxVias: string = Yii.t('wui-iqba-js', "nombre d'escales maximum");
    public readonly onlyAirport: string = Yii.t('wui-iqba-js', "(Aéroport uniquement)");
    public readonly fullServiceCarriersOnly: string = Yii.t('wui-iqba-js', "TRAVELPORT vol régulier uniquement");
    public readonly luggageInHold: string = Yii.t('wui-iqba-js', 'bagages enregistrés');
}

interface IAirSearchResumeSegment extends IAirSearchSegment {
    maxViasWording?: string;
    cabinWording?: string;
}

interface IAirSearchResume extends IAirSearchRequest {
    segment?: IAirSearchResumeSegment[];
}

@Component({
    selector: 'air-search-resume',
    templateUrl: './air-search-resume.component.html',
    styleUrls: ['./air-search-resume.component.scss']
})
export class AirSearchResumeComponent implements OnInit {
    @Input() public airSearchRequest: IAirSearchRequest = null;
    public airSearchResume: IAirSearchResume = null;
    public wording: Wording = new Wording();
    public icon: { [key: string]: IconDefinition } = {
        arrowRight: faArrowRight,
        check: faCheck,
        star: faStar,
        ban: faBan,
        suitCase: faSuitcase
    };
    public readonly permission: typeof IaqoboAirPermission = IaqoboAirPermission;
    public dateFormat: IMomentDateFormat = JSON.parse(wenji.ui.dateFormat);

    public ngOnInit(): void {
        this.initAirSearchResume();
    }

    private initAirSearchResume(): void {
        this.airSearchResume = {
            ...this.airSearchRequest,
            segment: this.getAirSearchResumeSegment(),
        };
    }

    private getAirSearchResumeSegment(): IAirSearchResumeSegment[] {
        return this.airSearchRequest?.segment?.map((segment: IAirSearchSegment): IAirSearchResumeSegment => {
            return {
                ...segment,
                maxViasWording: segment.maxVias >= 0 ? this.getMaxViasWording(segment.maxVias) : null,
                cabinWording: segment.cabin ? this.getCabinWording(segment.cabin) : null,
            };
        });
    }

    private getMaxViasWording(maxVias: number): string | null {
        return maxViasList.find((maxVia: IDropOption): boolean => maxVias === maxVia.value)?.label ?? null;
    }

    private getCabinWording(cabin: string): string | null {
        return cabinClassesList.find((cabinClass: IDropOption): boolean => cabin === cabinClass.value)?.label ?? null;
    }
}
